module.exports = __webpack_public_path__ + "static/img/zhuanli-1.27405d26.png";